import DealsIcon from '@assets/images/line-item/deals.svg';
import { Tag, TagProps } from './Tag';

export function DealTag({ className = '' }: TagProps) {
	return <Tag className={`${className} border-orange text-orange text-base`} classIcon='h-4 w-4' icon={<DealsIcon />} name='DEAL' />;
}

export function DealBorderTag({ className = '' }: TagProps) {
	return (
		<Tag
			className={`${className} pl-[3px] pr-1 py-[1px] border-orange text-orange border rounded-full text-xs`}
			classIcon='pl-0.5 h-3 w-3'
			icon={<DealsIcon />}
			name='DEAL'
		/>
	);
}
